<input
    kui-input
    type="number"
    [min]="field.min"
    [max]="field.max"
    key-number-validator
    #minField="ngModel"
    [required]="field.required"
    [ngModel]="values[field.id][0]"
    (ngModelChange)="changeNumber({ value: $event, index: 0 })"
    class="flex-1 mr-1"
    [class.border-danger]="error || minBiggerThanMax || (minField.invalid && (minField.dirty || minField.touched))"
/>
<input
    kui-input
    type="number"
    [min]="field.min"
    [max]="field.max"
    key-number-validator
    #maxField="ngModel"
    [required]="field.required"
    [ngModel]="values[field.id][1]"
    (ngModelChange)="changeNumber({ value: $event, index: 1 })"
    class="flex-1 ml-1"
    [class.border-danger]="error || minBiggerThanMax || (maxField.invalid && (maxField.dirty || maxField.touched))"
/>
@for (f of [minField, maxField]; track f; let i = $index) {
    @if (f.invalid && (f.dirty || f.touched)) {
        <div class="invalid-feedback d-block w-100">
            @if (f.errors["required"]) {
                <div>
                    {{ "FORMS.SHARED.REQUIRED" | translate: { field: "FORMS.MIN_MAX." + ids[i] | translate } }}
                </div>
            }
            @if (f.errors["min"]) {
                <div>
                    {{
                        "FORMS.NUMBER.MIN"
                            | translate
                                : {
                                      field: "FORMS.MIN_MAX." + ids[i] | translate,
                                      min: field.min,
                                  }
                    }}
                </div>
            }
            @if (f.errors["max"]) {
                <div>
                    {{
                        "FORMS.NUMBER.MAX"
                            | translate
                                : {
                                      field: "FORMS.MIN_MAX." + ids[i] | translate,
                                      max: field.max,
                                  }
                    }}
                </div>
            }
        </div>
    }
}
@if (minBiggerThanMax) {
    <div class="invalid-feedback d-block w-100">
        {{ "FORMS.MIN_MAX.MIN_LARGER_THAN_MAX" | translate }}
    </div>
}
@if (error) {
    <div class="invalid-feedback d-block">
        <div>{{ error }}</div>
    </div>
}
